import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { reduce } from "et3-type-guards";
import camelCase from "lodash/camelCase";
import startCase from "lodash/startCase";
import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../stores/user-store/advanced-store";
import KhattabatUserDescriptionCard from "./KhattabatUserDescriptionCard";
import KhattabatUserPhoto from "./KhattabatUserPhoto";

const KhattabatUserSummary = withLiteObserverAndTheme(() => {
  const {
    currentUserId,
    userData,
    getDescriptionAlignment,
    getUserStatusColor
  } = getUserAdvancedStore();
  const data = userData.get(currentUserId.get());

  const userStatus = reduce(() => data.status, "");
  const deactivationCounter = reduce(() => data.deactivationCounter, 0);
  const isTester = reduce(() => data.isTester, false);
  const isSilentBanned = reduce(() => data.isSilentBanned, 0);

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: "auto" }}>
          <KhattabatUserPhoto />
        </Grid>
        <Grid size={{ xs: 12, sm: "auto" }}>
          <Stack spacing={1} alignItems="flex-start">
            <Stack direction="row" spacing={1} alignItems="center">
              <Chip
                color={getUserStatusColor(userStatus)}
                label={startCase(camelCase(userStatus))}
              />
              {userStatus === "deactivated" ? (
                <Chip variant="outlined" label={`${deactivationCounter}`} />
              ) : null}
            </Stack>
            {isTester ? (
              <Chip
                color="warning"
                variant="outlined"
                label={i18n.get("TESTER")}
              />
            ) : null}
            {isSilentBanned === 1 ? (
              <Chip color="error" label={i18n.get("SILENT_BANNED")} />
            ) : null}
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: "grow" }}>
          <Stack spacing={2}>
            <KhattabatUserDescriptionCard
              titleKey="DESCRIPTION_ABOUT_ME"
              description={reduce(() => data.description, "")}
              descriptionStatus={reduce(() => data.descriptionStatus, "")}
              alignment={getDescriptionAlignment(
                reduce(() => data.descriptionLanguage, "")
              )}
            />
            <KhattabatUserDescriptionCard
              titleKey="DESCRIPTION_ABOUT_MY_PARTNER"
              description={reduce(() => data.peerDescription, "")}
              descriptionStatus={reduce(() => data.peerDescriptionStatus, "")}
              alignment={getDescriptionAlignment(
                reduce(() => data.peerDescriptionLanguage, "")
              )}
            />
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
});

export default KhattabatUserSummary;
